import axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';
import { Container, Spinner, Toast, ToastContainer } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { isEmpty, isLoggedIn, setLoginStatus } from '../helper/utils';

export const ToastContext = createContext();

console.log("DEV MODE:", process.env.REACT_APP_DEV_MODE);

function Landing() {
  const location = useLocation();
  const [toast, setToast] = useState(isLoggedIn() ? null : <LoginRequiredToast />);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (location.state?.fromSignOut) {
      setToast(<SignOutToast />);
    }
  }, [location.state]);

  useEffect(() => {
    axios.post(
      `${process.env.REACT_APP_SERVER_URL}/token/refresh/`, {}, { withCredentials: true }
    ).then(() => { setLoginStatus(true); }).catch(() => { setLoginStatus(false); });

    setLoaded(true);
  }, []);

  return loaded ? (
    <ToastContext.Provider value={{toast, setToast}}>
      {isLoggedIn() ? <Home /> : <Login />}
      {toast}
    </ToastContext.Provider>
  ) : <Spinner animation="border" variant="primary" />;
}

function Home() {
  return (
    <Container fluid className='d-flex flex-column align-items-center justify-content-center'>
      <h1 className='text-center'>Welcome!</h1>
      <p className='text-center'>Select a dashboard:</p>
      <Container
        fluid
        className='d-flex flex-row align-items-center justify-content-center'
        style={{columnGap: "50px"}}
      >
        <Card className='w-25 h-100'>
          <Card.Body>
            {/* TODO: Image preview of each dashboard (screenshot) */}
            {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
            <Card.Title className='text-center'>Market Analysis</Card.Title>
            {/* TODO: Description of each dashboard */}
            {/* <Card.Text></Card.Text> */}
            <LinkContainer
              to="/market-analysis/"
              style={{
                backgroundColor: "var(--sp-dark-blue)",
                borderColor: "var(--sp-dark-blue)",
              }}
            >
              <Button variant="primary" className='w-100'>View</Button>
            </LinkContainer>
          </Card.Body>
        </Card>
        <Card className='w-25 h-100'>
          <Card.Body>
            {/* TODO: Image preview of each dashboard (screenshot) */}
            {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
            <Card.Title className='text-center'>Load Monitoring</Card.Title>
            {/* TODO: Description of each dashboard */}
            {/* <Card.Text></Card.Text> */}
            <LinkContainer
              to="/load-monitoring/"
              style={{
                backgroundColor: "var(--sp-dark-blue)",
                borderColor: "var(--sp-dark-blue)",
              }}
            >
              <Button variant="primary" className='w-100'>View</Button>
            </LinkContainer>
          </Card.Body>
        </Card>
        <Card className='w-25 h-100'>
          <Card.Body>
            {/* TODO: Image preview of each dashboard (screenshot) */}
            {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
            <Card.Title className='text-center'>BESS Strategy</Card.Title>
            {/* TODO: Description of each dashboard */}
            {/* <Card.Text></Card.Text> */}
            <LinkContainer
              to="/bess-strategy/"
              style={{
                backgroundColor: "var(--sp-dark-blue)",
                borderColor: "var(--sp-dark-blue)",
              }}
            >
              <Button variant="primary" className='w-100'>View</Button>
            </LinkContainer>
          </Card.Body>
        </Card>
      </Container>
    </Container>
  );
}

const Login = () => {
  const { setToast } = useContext(ToastContext);
  const isDevMode = process.env.REACT_APP_DEV_MODE === 'true';

  useEffect(() => {
    if (!isDevMode) {
      const script = document.createElement('script');
      script.src = "https://telegram.org/js/telegram-widget.js?19";
      script.setAttribute('data-telegram-login', 'SDC_DR_Bot');
      script.setAttribute('data-size', 'large');

      const loginUrl = `${process.env.REACT_APP_SERVER_URL}/telegram-login/`;
      script.setAttribute('data-auth-url', loginUrl);
      script.setAttribute('data-request-access', 'write');
      script.setAttribute('data-onauth', 'handleTelegramLogin(user)');

      document.getElementById('telegram-login')?.appendChild(script);

      return () => {
        const el = document.getElementById('telegram-login');
        if (el) el.innerHTML = '';
      };
    }
  }, [isDevMode]);

  const handleTelegramLogin = (user) => {
    if (!isEmpty(user)) {
      axios.post(`${process.env.REACT_APP_SERVER_URL}/telegram-login/`, user, {
        withCredentials: true
      }).then(response => {
        if (response.data.User) {
          console.log('Login successful', response.data);
          setLoginStatus(true);
          setToast(<LoginSuccessToast />);
        } else {
          console.log('Unauthorized', response.data);
          setLoginStatus(false);
          setToast(<LoginFailedToast />);
        }
      }).catch(error => {
        console.error('Error during login', error);
        setLoginStatus(false);
        setToast(<LoginErrorToast />);
      });
    }
  };

  // Needed by Telegram widget
  if (!window.handleTelegramLogin) {
    window.handleTelegramLogin = handleTelegramLogin;
  }

  // Dev login button handler
  const handleDevLogin = () => {
    axios.post(`${process.env.REACT_APP_SERVER_URL}/dev-login/`, { id: "1234" }, {
      withCredentials: true
    }).then(response => {
      if (response.data?.User === true) {
        console.log('Dev login successful', response.data);
        setLoginStatus(true);
        setToast(<LoginSuccessToast />);
      } else {
        console.log('Unauthorized', response.data);
        setLoginStatus(false);
        setToast(<LoginFailedToast />);
      }
    }).catch(error => {
      console.error('Error during dev login', error);
      setLoginStatus(false);
      setToast(<LoginErrorToast />);
    });
  };


  return (
    <Container fluid className='h-100 p-0 d-flex flex-column justify-content-center align-items-center row-gap-2'>
      <h1>Log In With Telegram</h1>
      {
        isDevMode ? (
          <Button variant="primary" onClick={handleDevLogin}>
            Dev Login
          </Button>
        ) : (
          <div id="telegram-login"></div>
        )
      }
    </Container>
  );
};

// Toasts START
const SignOutToast = () => {
  const [show, setShow] = useState(true);
  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        bg="warning"
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">Sign Out</strong>
        </Toast.Header>
        <Toast.Body>Please terminate session on telegram to complete sign out</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

const LoginRequiredToast = () => {
  const [show, setShow] = useState(true);
  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        bg="info"
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">Login Required</strong>
        </Toast.Header>
        <Toast.Body>Please log in with Telegram to access all features.</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

const LoginSuccessToast = () => {
  const [show, setShow] = useState(true);
  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        bg="success"
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">Success</strong>
        </Toast.Header>
        <Toast.Body className='text-white'>Logged in successfully!</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

const LoginFailedToast = () => {
  const [show, setShow] = useState(true);
  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        bg="danger"
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">Login Failed</strong>
        </Toast.Header>
        <Toast.Body>Please check your username & password.</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

const LoginErrorToast = () => {
  const [show, setShow] = useState(true);
  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        bg="danger"
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">Login Error</strong>
        </Toast.Header>
        <Toast.Body>Please check your network and try again.</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
// Toasts END

export default Landing;
